import { render, staticRenderFns } from "./Modal-v2.vue?vue&type=template&id=5a57c564&scoped=true"
import script from "./Modal-v2.vue?vue&type=script&lang=js"
export * from "./Modal-v2.vue?vue&type=script&lang=js"
import style0 from "./Modal-v2.vue?vue&type=style&index=0&id=5a57c564&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a57c564",
  null
  
)

export default component.exports